import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { Moment } from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  getNYDate(): Moment {
    return moment(new Date()).tz('America/New_York');
  }

  getNearLegDate(tradeType): Moment {
    let today = moment(new Date()).tz('America/New_York');
    if (today.hour() >= 17) {
      today = today.add(1, 'day');
    }

    if (tradeType === 'TOD_TOM') {
      return today;
    }

    if (['SAT', 'SUN'].includes(today.format('ddd').toUpperCase())) {
      switch (today.format('ddd').toUpperCase()) {
        case 'SAT': today.add(2, 'day'); break;
        case 'SUN': today.add(1, 'day');
      }
    }
    return today;
  }

  getNearLegDateOnPreviousSessionDate(tradeType): Moment {
    let today = moment(new Date()).tz('America/New_York');
    if (today.hour() >= 17) {
      today = today.add(1, 'day');
    }

    today.subtract(1, 'day');

    if (tradeType === 'TOD_TOM') {
      return today;
    }

    if (['SAT', 'SUN'].includes(today.format('ddd').toUpperCase())) {
      switch (today.format('ddd').toUpperCase()) {
        case 'SAT': today.subtract(1, 'day'); break;
        case 'SUN': today.subtract(2, 'day');
      }
    }
    return today;
  }

  getTradeValueDate(nearLegDate, tenor): Moment {
    const weekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU'];
    const todayAsWeekday = nearLegDate.format('ddd').toUpperCase();

    if (tenor.toUpperCase() === 'W1') {
      return nearLegDate.add(7, 'day');
    }
    if (tenor.toUpperCase() === 'W2') {
      return nearLegDate.add(14, 'day');
    }

    if (tenor.toUpperCase() === 'ON' || tenor.toUpperCase() === 'TI') {
      if (weekDays.includes(todayAsWeekday)) {
        return nearLegDate.add(1, 'day');
      }
      if (todayAsWeekday === 'SAT') {
        return nearLegDate.add(2, 'day');
      }
      if (todayAsWeekday === 'FRI') {
        return nearLegDate.add(3, 'day');
      }
    }

    if (tenor.toUpperCase() === 'TOD_TOM') {
      return nearLegDate.add(1, 'day');
    }

    throw new Error('Invalid tenor');
    // DEFAULT
    // return nearLegDate.add(1, 'day');
  }
}
